import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';
import { useAuth } from './useAuth';

interface AuthorSuggestion {
  authorName: string;
  authorNameNormalized: string;
  bookCount: number;
  averageRating: string;
  reason: string;
}

export function useAuthorSuggestions() {
  const { user } = useAuth();

  return useQuery({
    queryKey: ['author-suggestions', user?.id],
    queryFn: async (): Promise<AuthorSuggestion[]> => {
      const { data, error } = await supabase.functions.invoke('suggest-authors-to-follow', {
        body: {}
      });

      if (error) throw error;
      return data.suggestions || [];
    },
    enabled: !!user,
    staleTime: 1000 * 60 * 30, // Cache for 30 minutes
  });
}
